import { useSiteStatusStore } from '~/stores/site-status';

export default defineNuxtPlugin({
  name: 'critical',

  async setup() {
    const { fetchParameters, parameters } = useParameters();
    const { fetchFeaturesFromApi, featuresFromApi } = useFeatureFlagsNew();
    const { fetchPaymentsFromApi, paymentsFromApi } = usePayments();
    const { appearance, getData: getAppearanceData } = useAppearanceStore();
    const siteStatus = useSiteStatusStore();

    const { cryptoList, fetchCryptoList } = useCrypto();
    const { payments } = useRuntimeConfig().public;
    const { crypto } = payments;

    function criticalReset() {
      useAppearanceStore().$reset();
      useParametersStore().$reset();
      useCryptoStore().$reset();
      useFeaturesStore().$reset();
    }

    async function criticalFetch(options: { force?: boolean } = {}) {
      const { force = false } = options;

      try {
        const promises: Promise<void>[] = [];

        if (force || !parameters.value) {
          promises.push(
            fetchParameters().catch((err) => {
              console.error('critical: erro ao buscar parameters', err);
            }),
          );
        }

        if (force || !featuresFromApi.value) {
          promises.push(
            fetchFeaturesFromApi().catch((err) => {
              console.error('critical: erro ao buscar features', err);
            }),
          );
        }

        // Sempre, mesmo sem `force`: o middleware de /games e os avisos leem
        // isto já na primeira navegação (Operações do site, ENG-915).
        promises.push(
          siteStatus.refresh().catch((err) => {
            console.error('critical: erro ao buscar site status', err);
          }),
        );

        if (force || !paymentsFromApi.value.deposit.length) {
          promises.push(
            fetchPaymentsFromApi().catch((err) => {
              console.error('critical: erro ao buscar payments', err);
            }),
          );
        }

        if (force || !appearance.logo || !appearance.icon_img) {
          promises.push(
            getAppearanceData().catch((err) => {
              console.error('critical: erro ao buscar appearance', err);
            }),
          );
        }

        if (crypto.activeDeposit || crypto.activeWithdraw) {
          if (force || !cryptoList.value.length) {
            promises.push(
              fetchCryptoList().catch((err) => {
                console.error('critical: erro ao buscar crypto list', err);
              }),
            );
          }
        }

        await Promise.all(promises);
      } catch (errorMessage) {
        console.error(`critical: ${errorMessage}`);
      }
    }

    await criticalFetch();

    siteStatus.startPolling();

    return {
      provide: {
        critical: {
          fetch: criticalFetch,
          reset: criticalReset,
        },
      },
    };
  },
});
